module.exports = __webpack_public_path__ + "media/images/upgrade_plan_success-bbfa67c51f7a204727327ad852200770.svg";